export default __webpack_public_path__ + "static/media/User.edbc50f2.svg";